import React from 'react';
import { amcTitleCase } from '../../utils';

interface AmcBasicInfoProps {
  amcBasicsDetails: {
    mfBasicsRegistrationCompanyData: {
      addressLine1: string;
      addressLine2: string;
      city: string;
      postalCode: string;
      fax: string;
      phone: string;
      homepage: string;
    }[];
    mfBasics: {
      mfBasicsType: string;
      companyName: string;
    }[];
  };
  issuingAuthority: string;
}

const AmcBasicInfo: React.FC<AmcBasicInfoProps> = ({
  amcBasicsDetails,
  issuingAuthority,
}) => {
  const { mfBasicsRegistrationCompanyData, mfBasics } = amcBasicsDetails;
  const amcBasicDetails = mfBasicsRegistrationCompanyData[0];
  const address = `${amcBasicDetails.addressLine1}, ${amcBasicDetails.addressLine2} ${amcBasicDetails.city} ${amcBasicDetails.postalCode}`;
  const auditors = mfBasics.filter((elm) => elm.mfBasicsType === 'AUDITOR');
  const custodians = mfBasics.filter((elm) => elm.mfBasicsType === 'CUSTODIAN');

  return (
    <div className="lil-py-12 lil-mt-12 sm:lil-mt-4 sm:lil-py-0">
      <div className="">
        <h4 className="lil-mb-6 lil-text-s-32">
          {amcTitleCase(issuingAuthority)} Key Information
        </h4>
        <table className="lil-w-full">
          <tbody>
            <tr>
              <td className="lil-p-5 lil-rounded-l-lg lil-bg-blue-50">
                <b>Auditors</b>
              </td>
              <td className="lil-font-medium lil-p-5 lil-rounded-r-lg lil-bg-blue-50">
                {auditors[0].companyName}
              </td>
            </tr>
            <tr>
              <td className="lil-p-5 lil-rounded-l-lg">
                <b>Custodians</b>
              </td>
              <td className="lil-font-medium lil-p-5 lil-rounded-r-lg">
                {custodians[0].companyName}
              </td>
            </tr>
            <tr>
              <td className="lil-p-5 lil-rounded-l-lg lil-bg-blue-50">
                <b>Address</b>
              </td>
              <td className="lil-font-medium lil-p-5 lil-rounded-r-lg lil-bg-blue-50">
                {address}
              </td>
            </tr>
            <tr>
              <td className="lil-p-5 lil-rounded-l-lg">
                <b>Fax Nos.</b>
              </td>
              <td className="lil-font-medium lil-p-5 lil-rounded-r-lg">
                {amcBasicDetails.fax}
              </td>
            </tr>
            <tr>
              <td className="lil-p-5 lil-rounded-l-lg lil-bg-blue-50">
                <b>Telephone Nos.</b>
              </td>
              <td className="lil-font-medium lil-p-5 lil-rounded-r-lg lil-bg-blue-50">
                {amcBasicDetails.phone}
              </td>
            </tr>
            <tr>
              <td className="lil-p-5 lil-rounded-l-lg">
                <b>Homepage</b>
              </td>
              <td className="lil-font-medium lil-p-5 lil-rounded-r-lg">
                <a href={`https://${amcBasicDetails.homepage}`}>
                  {amcBasicDetails.homepage}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AmcBasicInfo;



// WEBPACK FOOTER //
// ./components/amcNew/AmcBasicInfo.tsx